/** Друкована форма фінансової звітності (ч.1386): шапка, обидві форми набору в тис. грн, підписи. */
import { useNavigate, useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import {
  FORM_SET_TITLES, PERIOD_LABELS, financialStatements, formsFor,
} from '@/api/financialStatements';
import { orgs } from '@/api/catalogs';
import { EquityMatrix, FinSheetHeader, FinSignatures, FinStatementForm } from './FinStatementBlank';

export default function FinancialStatementPrintPage() {
  const navigate = useNavigate();
  const { id } = useParams();
  const docQ = useQuery({ queryKey: ['financial-statement', id], queryFn: () => financialStatements.get(id!), enabled: !!id });
  const d = docQ.data;
  const formsQ = useQuery({ queryKey: ['financial-statement-forms'], queryFn: financialStatements.forms, staleTime: 3_600_000 });
  const orgListQ = useQuery({ queryKey: ['orgs'], queryFn: () => orgs.list({ limit: 200 }) });
  const org = orgListQ.data?.items.find((o) => o.id === d?.organization_id);
  if (!d || !formsQ.data) return <div className="card">Завантаження…</div>;
  // ч.1388: за рік у повному наборі — чотири форми (Ф3 і Ф4 — окремими сторінками).
  const forms = formsFor(d.form_set, d.period_quarter).map((c) => formsQ.data!.find((f) => f.form_code === c)!).filter(Boolean);
  return (
    <div style={{ background: '#fff', color: '#000', minHeight: '100vh' }}>
      <style>{`
        @media print {
          .no-print { display: none !important; }
          @page { size: A4 portrait; margin: 1.2cm; }
          .print-page { page-break-before: always; }
          .print-page:first-of-type { page-break-before: auto; }
          nav, aside, header { display: none !important; }
          body { background: #fff !important; }
        }
        .fs-print table.tch { color: #000; }
        .fs-print table.tch th, .fs-print table.tch td { border: 1px solid #999; }
      `}</style>
      <div className="no-print" style={{ display: 'flex', gap: '0.5rem', padding: '0.6rem 1rem', borderBottom: '1px solid #e2e8f0', alignItems: 'center' }}>
        <b>Друк: фінансова звітність — {FORM_SET_TITLES[d.form_set]} — {PERIOD_LABELS[d.period_quarter]} {d.period_year}</b>
        <div style={{ marginLeft: 'auto', display: 'flex', gap: '0.5rem' }}>
          <button className="primary" onClick={() => window.print()}>друкувати</button>
          <button onClick={() => navigate(`/reports/financial/${id}`)}>до документа</button>
        </div>
      </div>
      <div className="fs-print" style={{ maxWidth: 900, margin: '0 auto', padding: '1rem' }}>
        {forms.map((f, i) => (
          <div key={f.form_code} className="print-page" style={i ? { marginTop: '1.5rem' } : undefined}>
            <FinSheetHeader doc={d} org={org} formCode={f.form_code} print />
            {f.kind === 'matrix'
              ? <EquityMatrix form={f} values={d.values ?? {}} readOnly print />
              : <FinStatementForm form={f} doc={d} values={d.values ?? {}} readOnly print />}
            <FinSignatures org={org} print />
          </div>
        ))}
      </div>
    </div>
  );
}
